const condensedReport = {
  condensedReport: 'Condensed Report',
  sites: 'Sites',
  equipmentModels: 'Equipment Type',
  equipmentServices: 'Service Type',
  buttonText: 'Export Report',
  from: 'From',
  to: 'To',
};

export default condensedReport;
